/**
 * Clés de cache du domaine `session` — l'utilisateur connecté, ses
 * organisations, ses notifications, et ses faits premium.
 *
 * Voir `src/hooks/profile/keys.ts` pour le pourquoi de la fabrique.
 */
export const sessionKeys = {
  all: ['session'] as const,

  /**
   * Y a-t-il un utilisateur Cognito connu d'Amplify ? Porte d'entrée de `me()` et
   * `premiumStatus()` (cf. `queries/useAuthenticatedUserQuery`). Sous `all` à dessein :
   * `refreshSession()` après une connexion l'invalide avec le reste.
   */
  authenticated: () => [...sessionKeys.all, 'authenticated'] as const,

  /** `GET /me` + organisations + notifications, en un seul appel composé. */
  me: () => [...sessionKeys.all, 'me'] as const,

  /** Relecture silencieuse de `GET /me` seul, recopiée dans `me()` (cf. `hooks/useRefreshMe`). */
  meRefresh: () => [...sessionKeys.all, 'meRefresh'] as const,

  /** `GET /me/premium-status` : les faits serveur du verdict premium. */
  premiumStatus: () => [...sessionKeys.all, 'premiumStatus'] as const,

  mutations: () => [...sessionKeys.all, 'mutation'] as const,
} as const;
